import { request } from '../../../lib/request_other';

/*
    获取域名列表
*/
// 这是为了和后台本地联调 不能删除
// const baseUrl = 'http://10.12.68.75:8080';

export function baseInfo(params) {
    return request({
        // url: '{#npgw}/newDomain/baseInfo',
        url: `{#npgw}/mwebapi/newDomain/baseInfo`,
        method: 'GET',
        params,
        timeout: 60000
    });
}
/*
    获取域名有效期和服务商名称
*/
export function domainExpireDateAndServiceName(data, params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/domainExpireDateAndServiceName`,
        method: 'post',
        data,
        params,
        dataType: 'form',
        timeout: 60000
    });
}
/*
    解析规则
*/
export function parsingRules(params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/parsingRules`,
        method: 'get',
        params,
        timeout: 60000
    });
}
/*
    一键解析
*/
export function oneKeyVerification(data, params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/oneKeyVerification`,
        method: 'post',
        data,
        params,
        timeout: 60000
    });
}

/*
    域名校验
*/
export function checkDomainValid(params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/checkDomainValid`,
        method: 'get',
        params,
        timeout: 60000,
    });
}

/*
    获取别名信息
*/
export function aliasInfo(params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/aliasInfo`,
        method: 'get',
        params,
        timeout: 60000
    });
}

/*
    获取别名解析列表
*/
export function aliasList(params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/V2/alias/parseRecordInfo`,
        method: 'get',
        params,
        timeout: 60000
    });
}

/*
    域名绑定
*/
export function bindDomain(data) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/bindDomain`,
        method: 'post',
        data,
        timeout: 60000
    });
}

/*
    域名变更
*/
export function updateDomain(data, logObj) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/bindDomain`,
        method: 'post',
        data,
        logObj,
        logFlag: {
            appName: '域名绑定',
            columnName: '域名管理',
            operModule: '变更域名',
        },
        timeout: 60000
    });
}

/*
    域名别名绑定
*/
export function addAlias(data, params, logObj) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/addAlias`,
        method: 'post',
        data,
        params,
        timeout: 60000,
        logObj,
        logFlag: {
            appName: '域名绑定',
            columnName: '别名管理',
            operModule: '添加别名',
        },
    });
}

/*
    域名别名删除
*/
export function deleteAliasDomain(data, params, logObj) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/deleteAliasDomain`,
        method: 'post',
        data,
        params,
        dataType: 'form',
        timeout: 60000,
        logObj,
        logFlag: {
            appName: '域名绑定',
            columnName: '别名管理',
            operModule: '删除别名',
        },
    });
}

/*
    解绑主域名
*/
export function release(params, logObj) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/release`,
        method: 'get',
        params,
        logObj,
        logFlag: {
            appName: '域名绑定',
            columnName: '域名管理',
            operModule: '解绑域名',
        },
        timeout: 60000
    });
}

/*
    高级设置 智能跳转
*/

export function getSkip(params) {
    return request({
        url: `{#npgw}/setting/auto_skip`,
        method: 'get',
        params,
        timeout: 1000 * 60,
    });
}

export function autoSkip(params, logObj) {
    return request({
        url: `{#npgw}/setting/auto_skip`,
        method: 'get',
        params,
        timeout: 1000 * 60,
        logObj,
        logFlag: {
            appName: '域名绑定',
            columnName: '高级设置',
            operModule: '变更智能跳转状态',
        },
    });
}

/*
    重新加载CDN
*/
export function bindCdn(data, params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/bindCdn`,
        method: 'post',
        data,
        params,
        timeout: 60000
    });
}

/*
    检查CDN
*/
export function checkCdn(params) {
    return request({
        url: `{#npgw}/mwebapi/ssl/common/checkDomainRoute`,
        method: 'get',
        params,
        timeout: 60000
    });
}

/*
    获取自定义背景&logo
*/
export function getCustomLogoBackground(params) {
    return request({
        url: `{#bm}/bm/customLogoBackground`,
        method: 'get',
        params,
    });
}

/*
    获取自定义oem配置项
*/
export function findByProductCode(params) {
    return request({
        url: `{#bm}/bm/productCustomConfig/findByProductCode`,
        method: 'get',
        params,
    });
}

/*
    自定义背景&logo add update
*/
export function setCustomLogoBackground(data) {
    return request({
        url: `{#bm}/bm/customLogoBackground`,
        method: 'post',
        data,
    });
}

/*
    保存或更新IP
*/
export function saveOrUpdateIp(data) {
    return request({
        url: `{#npgw}/pms/tenantRecord/saveOrUpdate`,
        method: 'post',
        data,
        // dataType: 'form',
    });
}

/*
    根据租户ID和key查询信息
*/
export function findListByTenantIdOrKeyWord(data) {
    return request({
        url: `{#npgw}/pms/tenantRecord/findListByTenantIdOrKeyWord`,
        method: 'post',
        data,
        // dataType: 'form',
    });
}

/*
    跳转设计云
*/
export function privateDesignerLoginUrl(params) {
    return request({
        url: `{#npgw}/local/privateDesignerLoginUrl`,
        method: 'get',
        params,
        // dataType: 'form',
    });
}

/*
    获取当前租户自定义菜单
*/
export function getCustomMenuListByTenantId(params) {
    return request({
        url: `{#npgw}/pms/pcpTenantCustomMenu/v2/getCustomMenuListByTenantId`,
        method: 'get',
        params,
        // dataType: 'form',
    });
}

/*
    保存自定义菜单
*/
export function saveCustomMenu(data) {
    return request({
        url: `{#npgw}/pms/pcpTenantCustomMenu/init/customer/menu`,
        method: 'post',
        data,
        // dataType: 'form',
    });
}

/*
    编辑单条菜单数据
*/
export function saveCustomMenuInfo(data) {
    return request({
        url: `{#npgw}/pms/pcpTenantCustomMenu/edit/custom/menuName`,
        method: 'post',
        data,
        // dataType: 'form',
    });
}

/*
    重置系统菜单
*/
export function resetSystemMenu(params) {
    return request({
        url: `{#npgw}/pms/pcpTenantCustomMenu/reset/customer/menu`,
        method: 'get',
        params,
        // dataType: 'form',
    });
}

/*
    获取站群列表
*/
export function getSiteGroup(params) {
    return request({
        url: `{#bm}/bm/siteGroup/list`,
        method: 'get',
        params,
        // dataType: 'form',
    });
}

// 保存站群域名

export function saveSiteDomain(data) {
    return request({
        url: `{#bm}/bm/siteGroup/save`,
        method: 'post',
        data,
        // dataType: 'form',
    });
}

// 获取站点首页地址

export function getHomeUrl(params) {
    return request({
        url: `{#npgw}/bm/comm/getHomeUrl`,
        method: 'get',
        params,
        // dataType: 'form',
    });
}

// 获取获取用户详情
export function getByIdAndMemberCode(params) {
    return request({
        url: `{#bm}/bm/admin/getByIdAndMemberCode`,
        method: 'get',
        params,
        // dataType: 'form',
    });
}

// 1.查询页面列表接口（）
// 2.更新PC和MO页面映射关系（/page/updatePcMoPageMap）
// 3.查询PC和MO页面映射关系列表（/page/getPcMoPageMapList）
export function getPageNoHomeAndDefault(data) {
    return request({
        url: `{#npgw}/page-service/page/getPageNoHomeAndDefault?instanceId=${data.instanceId}&operStatus=${data.operStatus}&pageType=${data.pageType}&viewType=${data.viewType}&appId=${data.appId}&contentType=${data.contentType}`,
        method: 'post',
        data,
        // dataType: 'form',
    });
}
// 获取pc m 的table list
export function getPcMoPageMapNoContentList(params) {
    return request({
        url: `{#npgw}/page-service/page/getPcMoPageMapNoContentList`,
        method: 'get',
        params,
        // dataType: 'form',
    });
}
// 更新pc和mo综合页和列表页页面映射关系
export function saveOrUpdatePcMoPageMap(data) {
    return request({
        url: `{#npgw}/page-service/page/saveOrUpdatePcMoPageMap?instanceId=${data.instanceId}&pageIdM=${data.pageIdM}&pageIdP=${data.pageIdP}`,
        method: 'post',
        data,
        // dataType: 'form',
    });
}

// ssl 301状态
export function get301(params) {
    return request({
        url: `{#npgw}/mwebapi/ssl/get301`,
        method: 'get',
        params,
        // dataType: 'form',
    });
}

export function stop301(data, params, logObj) {
    return request({
        url: `{#npgw}/mwebapi/ssl/stop301`,
        method: 'post',
        data,
        params,
        dataType: 'form',
        logObj,
        logFlag: {
            appName: '域名绑定',
            columnName: '域名管理',
            operModule: '关闭https跳转',
            title: '关闭https跳转'
        },
    });
}

export function start301(data, params, logObj) {
    return request({
        url: `{#npgw}/mwebapi/ssl/start301`,
        method: 'post',
        data,
        params,
        dataType: 'form',
        logObj,
        logFlag: {
            appName: '域名绑定',
            columnName: '域名管理',
            operModule: '开启https跳转',
            title: '开启https跳转'
        },
    });
}

/*
    同名域名释放
*/
export function releaseV2(data, params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/releaseV2`,
        method: 'post',
        data,
        params,
        dataType: 'form',
    });
}
/*
    查询释放状态
*/
export function getDomainOccupyInfo(params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/getDomainOccupyInfo`,
        method: 'get',
        params,
    });
}

/*
    检查域名状态
*/
export function statusCheck(data, params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/statusCheck`,
        method: 'post',
        data,
        params,
        timeout: 60000
        // dataType: 'form',
    });
}

/*
* 跳过当前步骤，手动更新状态
*/
export function updateParse(data) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/V2/updateIsParseBy`,
        method: 'post',
        data,
        timeout: 60000,
        dataType: 'form',
    });
}

/*
    检查别名状态
*/
export function aliasCheck(data, params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/V2/check/aliasStatus`,
        method: 'post',
        data,
        params,
        timeout: 60000
        // dataType: 'form',
    });
}

// 新需求  查询网站的各个状态

export function getDomainStep(params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/V2/getDomainOperRecordBy`,
        method: 'get',
        params,
        timeout: 60000
    });
}

/*
*   解析结果
*   tenantId 租户id
*   terminal=1 [pc1 m2]
*   isAlias=1 [主域1 别名2]
*   domain=uu190809.xuoumaill.cn
*/
export function parsingResult(params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/V2/check/domainParseRecord`,
        method: 'get',
        params,
        timeout: 60000
    });
}

/*
   新流程 解析规则
*/
export function parsingRulesV2(params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/V2/parsingRules`,
        method: 'get',
        params,
        timeout: 60000
    });
}

// 新流程 绑定/变更

/*
    域名绑定
*/
export function bindDomainV2(data, params, logObj) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/V2/bindDomain`,
        method: 'post',
        data,
        params,
        timeout: 60000,
        logObj,
        logFlag: {
            appName: '域名绑定',
            columnName: '域名管理',
            operModule: '绑定域名',
        }, 
    });
}

/*
    域名变更
*/
export function updateDomainV2(data, params, logObj) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/V2/bindDomain`,
        method: 'post',
        data,
        params,
        logObj,
        logFlag: {
            appName: '域名绑定',
            columnName: '域名管理',
            operModule: '变更域名',
        },
    });
}

// 新域名解析验证
export function mainDomainAndAwsParseVerify(data, domain, params) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/V2/mainDomainAndAwsParseVerify?domain=${domain}`,
        method: 'post',
        data,
        params,
        timeout: 60000
    });
}

// 新域名未备案添加
export function siteInitDomain(data) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/V2/sop/siteInitDomain`,
        method: 'post',
        data,
    });
}

export function updateAliasAbsolutePathJumpSwitch(data) {
    return request({
        url: `{#npgw}/mwebapi/newDomain/V2/updateAliasAbsolutePathJumpSwitch`,
        method: 'post',
        data,
    });
}

// 后台点击上线按钮，上线完成时调用知识库自动学习接口：
export function initStudy(params) {
    return request({
        url: `{#npgw}/visitormanager/intelligent/dataWarehouse/initStudy`,
        method: 'get',
        params,
    });
}